<template>
  <div>
    <tci-about-us :title="$t('organization.title')">
      <v-row>
        <v-spacer></v-spacer>
        <v-img width="50" src = "../assets/org_logo.jpg">
        </v-img>
        <v-spacer></v-spacer>
      </v-row>
      <v-row class="text-center">
        <v-col>{{ $t('organization.address') }} </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
         <v-img width="400" :src='$i18n.locale=="zh"?require("../assets/organization_zh.jpg"):require("../assets/organization_ja.jpg")'></v-img>
         <v-spacer></v-spacer>
      </v-row>
    </tci-about-us>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciAboutUs from "@/components/TciAboutUs.vue";
import TciContactFooter from "@/components/TciContactFooter.vue";

export default {
    name: "CompanyOrganization",
    components: {
      "tci-about-us": TciAboutUs,
      "tci-contact-footer": TciContactFooter
  }
}
</script>
